import React, { useEffect } from 'react';
import { Badge, Nav, NavDropdown } from 'react-bootstrap';
// import { House, Bell, Gear, Users, LogOut } from 'react-bootstrap-icons';
import { IoHomeSharp, IoChatbox, IoDocumentAttach } from "react-icons/io5";
import { ImUsers } from "react-icons/im";
import { FaGear, FaCalendarCheck, FaClipboardQuestion, FaPaperPlane } from "react-icons/fa6";
import { IoMdLogOut } from "react-icons/io";
import { MdEditCalendar, MdFiberNew, MdSwapHorizontalCircle, MdTableChart, MdWorkOff} from "react-icons/md";
import { TfiAgenda } from "react-icons/tfi";
import { MdNewReleases } from "react-icons/md"


// import './Sidebar.css'; // pour un peu de style custom
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { signOut } from 'aws-amplify/auth';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../../contexts/AuthContext';
import { AgendaUser } from '../../../graphql/API';
import { useNotification } from '../../../contexts/NotificationProvider';
import useNotificationStorageService from '../NotificationStorageService';

interface SideBarProps {
  user: any;
  // user: Partial<AgendaUser>;
}

const Sidebar: React.FC<SideBarProps> = ({ user }) => {
  // I18N
  const { t } = useTranslation();
  // NAVIGATION
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;
  // NOTIFICATION
  const notificationContext = useNotification();
  const postCount = notificationContext?.postCount;
  const shiftCount = notificationContext?.shiftCount;
  const openShiftCount = notificationContext?.openShiftCount;
  const confirmShiftCount = notificationContext?.confirmShiftCount;
  const documentCount = notificationContext?.documentCount;
  const swapRequestCount = notificationContext?.swapRequestCount;
  const leaveRequestCount = notificationContext?.leaveRequestCount;
  const postLink = notificationContext?.postLink;
  const shiftLink = notificationContext?.shiftLink;
  const openShiftLink = notificationContext?.openShiftLink;
  const confirmShiftLink = notificationContext?.confirmShiftLink;

  // const handleNavigation = (path: string) => {
  //   navigate(path);
  // };

  const logOut = () => {
    signOut();
    localStorage.clear();
    navigate('/');
  }

  return (
    <div data-bs-theme="dark" className="sidebar d-flex flex-column align-items-center py-2 bg-body-tertiary">
      
      <Nav className="sidebar_content flex-column w-100 align-items-center">
        {/* <Nav.Link onClick={() => handleNavigation(t('link.dashboard'))} className="sidebar-icon active"> */}
        <Nav.Link as={NavLink} to={t('link.dashboard')} 
          onClick={(e) => {
            if (window.location.pathname === t('link.dashboard')) {
              e.preventDefault(); // prevent navigation
            }
          }}
          className={`sidebar-icon ${isActive(t('link.dashboard')) ? 'active sidebar-active-icon text-primary' : ''}`}>
          <IoHomeSharp size={24} title={t('navBar.dashboard')} /> 
          {/* <span className="sidebar-text">Dashboard</span> */}
        </Nav.Link>
        { user?.type === "MANAGER" ?
          <>
            {/* <Nav.Link onClick={() => handleNavigation(t('link.scheduler'))} className="sidebar-icon"> */}
            {/* <Nav.Link as={NavLink} to={t('link.scheduler')} 
              onClick={(e) => {
                if (window.location.pathname === t('link.scheduler')) {
                  e.preventDefault(); // prevent navigation
                }
              }}
              className={`sidebar-icon ${isActive(t('link.scheduler')) ? 'active sidebar-active-icon text-primary' : ''}`}>
              <MdEditCalendar size={24} title={t('navBar.scheduler')}/>
            </Nav.Link> */}
            <NavDropdown title={
              <MdEditCalendar size={24} title={t('navBar.scheduler')} 
              className={`${isActive(t('link.scheduler')) || isActive(`${t('link.scheduler')}${t('link.open_shifts')}`) 
              ? 'active sidebar-active-icon text-primary' : ''}`}/>} className="dropend sidebar-dropdown" >
                
                <div className="dropdown-arrow"></div>
                <NavDropdown.Item href={t('link.scheduler')} className="d-flex align-items-center dropdown_list_item"><TfiAgenda size={24} title={t('navBar.scheduler')} style={{marginRight: 10}}/>{t('navBar.scheduler')}</NavDropdown.Item>
                <NavDropdown.Item href={`${t('link.scheduler')}${t('link.open_shifts')}`} className="d-flex align-items-center dropdown_list_item"><TfiAgenda size={24} title={t('navBar.scheduler')} style={{marginRight: 10}}/>{t('home.manageOpenShift')}</NavDropdown.Item>
            </NavDropdown>
            {/* <Nav.Link onClick={() => handleNavigation(t('link.agenda_management')} className="sidebar-icon"> */}
            {/* <Nav.Link as={NavLink} to={t('link.agenda_management')} 
              onClick={(e) => {
                if (window.location.pathname === t('link.agenda_management')) {
                  e.preventDefault(); // prevent navigation
                } else {
                  handleNavigation(t('link.agenda_management'));
                }
              }}
              className={`sidebar-icon ${isActive(t('link.agenda_management')) ? 'active sidebar-active-icon text-primary' : ''}`}>
              <FaCalendarCheck size={24} title={t('navBar.agendaManager')}/> 
            </Nav.Link> */}
            <NavDropdown title={
              <FaCalendarCheck title={t('navBar.agendaManager')} 
              className={`${isActive('/agenda') || isActive(t('link.agenda_management')) || isActive(t('link.table_shift')) || 
                 isActive(t('link.excel_shift')) ? 'active sidebar-active-icon text-primary' : ''}`} size={24} />} 
              className="dropend sidebar-dropdown" >
                
                <div className="dropdown-arrow"></div>
                <NavDropdown.Item href="/agenda" className="d-flex align-items-center dropdown_list_item"><TfiAgenda size={24} title="Agenda" style={{marginRight: 10}}/> Agenda</NavDropdown.Item>
                <NavDropdown.Item href={`/agenda/${t('link.management')}`} className="d-flex align-items-center dropdown_list_item"><TfiAgenda size={24} title={t('navBar.agendaManager')} style={{marginRight: 10}}/> {t('navBar.agendaManager')}</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown title={
                  <>
                    <FaCalendarCheck title={t('navBar.shift')} 
                      className={`${isActive(t('link.table_shift')) || isActive(t('link.excel_shift')) ? 'active sidebar-active-icon text-primary' : ''}`} size={24} />
                    <span style={{ marginLeft: '10px' }}>{t('navBar.shift')}</span>
                  </>} 
                  className="dropend sidebar-dropdown nested-dropdown">
                  <div className="dropdown-arrow"></div>
                  <NavDropdown.Item href={t('link.table_shift')} className="d-flex align-items-center dropdown_list_item"><MdTableChart size={24} title={t('navBar.agendaManager')} style={{marginRight: 10}}/> {t('navBar.table')}</NavDropdown.Item>
                  <NavDropdown.Item href={t('link.excel_shift')} className="d-flex align-items-center dropdown_list_item"><MdTableChart size={24} title={t('navBar.agendaManager')} style={{marginRight: 10}}/> {t('navBar.spreadsheet')}</NavDropdown.Item>
                </NavDropdown>
                <NavDropdown title={
                  <>
                    <FaCalendarCheck title={t('navBar.open_shift')} 
                      className={`${isActive(t('link.table_open_shift')) || isActive(t('link.excel_open_shift')) ? 'active sidebar-active-icon text-primary' : ''}`} size={24} />
                    <span style={{ marginLeft: '10px' }}>{t('navBar.open_shift')}</span>
                  </>} 
                  className="dropend sidebar-dropdown nested-dropdown">
                  <div className="dropdown-arrow"></div>
                  <NavDropdown.Item href={t('link.table_open_shift')} className="d-flex align-items-center dropdown_list_item"><MdTableChart size={24} title={t('navBar.agendaManager')} style={{marginRight: 10}}/> {t('navBar.table')}</NavDropdown.Item>
                  <NavDropdown.Item href={t('link.excel_open_shift')} className="d-flex align-items-center dropdown_list_item"><MdTableChart size={24} title={t('navBar.agendaManager')} style={{marginRight: 10}}/> {t('navBar.spreadsheet')}</NavDropdown.Item>
                </NavDropdown>
                {/* <NavDropdown.Divider />
                <NavDropdown.Item href="/open_shifts" className="d-flex align-items-center dropdown_list_item"><FaPaperPlane size={24} title={t('home.openShiftAvail')} style={{marginRight: 10}}/> {t('home.openShiftAvail')}</NavDropdown.Item> */}
            </NavDropdown>
          </>
        :
          // <Nav.Link onClick={() => handleNavigation('/agenda')} className="sidebar-icon">
          <>
            <Nav.Link as={NavLink} to='/agenda' 
                onClick={(e) => {
                  if (window.location.pathname === '/agenda') {
                    e.preventDefault(); // prevent navigation
                  }
                }}
                className={`sidebar-icon ${isActive('/agenda') ? 'active sidebar-active-icon text-primary' : ''}`}  style={{position: 'relative'}}>
              <FaCalendarCheck size={24} title="Agenda"/> 
              { confirmShiftCount && confirmShiftCount > 0 ?
                <Badge pill bg="danger" style={{position: 'absolute', top:5, right: 5, fontSize: 8}} >
                  {confirmShiftCount}
                </Badge>
              :
                <span></span>
              }
            </Nav.Link>       
          </>
        }

        <Nav.Link as={NavLink} to={t('link.shifts')}
          onClick={(e) => {
            if (window.location.pathname === t('link.shifts')) {
              e.preventDefault(); // prevent navigation
            }
          }}
          className={`sidebar-icon ${isActive(t('link.shifts')) ? 'active sidebar-active-icon text-primary' : ''}`} style={{position: 'relative'}}>
            <MdNewReleases size={24} title={t('home.shiftReceived')}/> 
            { shiftCount && shiftCount > 0 ?
              <Badge pill bg="danger" style={{position: 'absolute', top:5, right: 5, fontSize: 8}}>
                {shiftCount}
              </Badge>
            :
              <span></span>
            }
        </Nav.Link> 

        <Nav.Link as={NavLink} to={t('link.open_shifts')} 
          onClick={(e) => {
            if (window.location.pathname === t('link.open_shifts')) {
              e.preventDefault(); // prevent navigation
            }
          }}
          className={`sidebar-icon ${isActive(t('link.open_shifts')) ? 'active sidebar-active-icon text-primary' : ''}`} style={{position: 'relative'}}>
          <FaPaperPlane size={24} title={t('home.openShiftAvail')}/> 
          { openShiftCount && openShiftCount > 0 ?
            <Badge pill bg="danger" style={{position: 'absolute', top:5, right: 5, fontSize: 8}} >
              {openShiftCount}
            </Badge>
          :
            <span></span>
          }
        </Nav.Link>  

        {/* <Nav.Link onClick={() => handleNavigation('/posts')} className="sidebar-icon"> */}
        <Nav.Link as={NavLink} to={postLink && postLink != "" ? `${t('link.posts')}/${postLink}`: t('link.posts')} 
          onClick={(e) => {
            if (postLink && postLink != "") {
              if (window.location.pathname === t('link.posts') + '/' + postLink) {
                e.preventDefault(); // prevent navigation
              }
            } else {
              if (window.location.pathname === t('link.posts')) {
                e.preventDefault(); // prevent navigation
              }
            }
          }}
          className={`sidebar-icon ${isActive(t('link.posts')) ? 'active sidebar-active-icon text-primary' : ''}`} style={{position: 'relative'}}>
          <IoChatbox size={24} title="Posts"/> 
          { postCount && postCount > 0 ?
            <Badge pill bg="danger" style={{position: 'absolute', top:5, right: 5, fontSize: 8}} >
              {postCount}
            </Badge>
          :
            <span></span>
          }
        </Nav.Link>
        { user?.type === "MANAGER" ?
          <>
            <div style={{position: 'relative'}}> 
              { (documentCount && documentCount > 0) ?
                <Badge pill bg="danger" style={{position: 'absolute', top:5, right: 5, fontSize: 8}} >
                  {documentCount}
                </Badge>
              :
                <span></span>
              }
            
              <NavDropdown title={
                <IoDocumentAttach  size={24} title="Documents" 
                className={`${isActive('/documents') || isActive(`${t('link.worker')}/documents`)
                ? 'active sidebar-active-icon text-primary' : ''}`}/>} className="dropend sidebar-dropdown">
                  
                  <div className="dropdown-arrow"></div>
                  <NavDropdown.Item href="/documents" className="d-flex align-items-center dropdown_list_item"><IoDocumentAttach size={24} title={'navBar.documents'} style={{marginRight: 10}}/>{t('navBar.documents')}</NavDropdown.Item>
                  <NavDropdown.Item href={`${t('link.worker')}/documents`} className="d-flex align-items-center dropdown_list_item"><IoDocumentAttach size={24} title={t('navBar.myDocuments')} style={{marginRight: 10}}/> {t('navBar.myDocuments')}</NavDropdown.Item>
              </NavDropdown>
            </div>
          </>
        :
          <Nav.Link as={NavLink} to={`${t('link.worker')}/documents`}
            onClick={(e) => {
              if (window.location.pathname === `${t('link.worker')}/documents`) {
                e.preventDefault(); // prevent navigation
              }
            }}
            className={`sidebar-icon ${isActive(`${t('link.worker')}/documents`) ? 'active sidebar-active-icon text-primary' : ''}`} style={{position: 'relative'}}>
            <IoDocumentAttach  size={24} title="Documents" /> 
            { documentCount && documentCount > 0 ?
              <Badge pill bg="danger" style={{position: 'absolute', top:5, right: 5, fontSize: 8}}>
                {documentCount}
              </Badge>
            :
              <span></span>
            }
          </Nav.Link>
        }
        { user?.type === "MANAGER" ?
          <>
            <div style={{position: 'relative'}}> 
              { (swapRequestCount || leaveRequestCount) && (swapRequestCount > 0 || leaveRequestCount > 0) ?
                <Badge pill bg="danger" style={{position: 'absolute', top:5, right: 5, fontSize: 8}} >
                  {swapRequestCount + leaveRequestCount}
                </Badge>
              :
                <span></span>
              }
            
              <NavDropdown title={
                <FaClipboardQuestion size={24} title={t('navBar.scheduler')} 
                className={`${isActive(t('link.swap_management')) || isActive(t('link.suggested_requests_swap')) || isActive(t('link.requests_swap')) ||
                  isActive(t('link.leave_management')) || isActive(t('link.requests_leave')) || isActive(t('link.leave_create'))
                ? 'active sidebar-active-icon text-primary' : ''}`}/>} className="dropend sidebar-dropdown">
                  
                  <div className="dropdown-arrow"></div>
                  <NavDropdown.Item href={t('link.swap_management')} className="d-flex align-items-center dropdown_list_item"><MdSwapHorizontalCircle size={24} title={t('request.managerTab')} style={{marginRight: 10}}/>{t('request.managerTab')}</NavDropdown.Item>
                  <NavDropdown.Item href={t('link.suggested_requests_swap')} className="d-flex align-items-center dropdown_list_item"><MdSwapHorizontalCircle size={24} title={t('request.receiveTab')} style={{marginRight: 10}}/> {t('request.receiveTab')}</NavDropdown.Item>
                  <NavDropdown.Item href={t('link.requests_swap')} className="d-flex align-items-center dropdown_list_item"><MdSwapHorizontalCircle size={24} title={t('request.giveTab')} style={{marginRight: 10}}/>{t('request.giveTab')}</NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item href={t('link.leave_management')} className="d-flex align-items-center dropdown_list_item"><MdWorkOff size={24} title={t('request.managerLeaveTab')} style={{marginRight: 10}}/> {t('request.managerLeaveTab')}</NavDropdown.Item>
                  <NavDropdown.Item href={t('link.requests_leave')} className="d-flex align-items-center dropdown_list_item"><MdWorkOff size={24} title={t('request.leaveTab')} style={{marginRight: 10}}/> {t('request.leaveTab')}</NavDropdown.Item>
                  <NavDropdown.Item href={t('link.leave_create')} className="d-flex align-items-center dropdown_list_item"><MdWorkOff size={24} title={t('request.createLeaveTab')} style={{marginRight: 10}}/> {t('request.createLeaveTab')}</NavDropdown.Item>
              </NavDropdown>
            </div>
          </>
        :
            <NavDropdown title={
              <FaClipboardQuestion title={t('navBar.agendaManager')} 
              className={`${isActive(t('link.requests_swap')) || isActive(t('link.requests_leave')) || 
                isActive(t('link.leave_create')) ? 'active sidebar-active-icon text-primary' : ''}`} size={24} />} 
              className="dropend sidebar-dropdown" >
                
                <div className="dropdown-arrow"></div>
                <NavDropdown.Item href={t('link.requests_swap')} className="d-flex align-items-center dropdown_list_item"><MdSwapHorizontalCircle size={24} title={t('request.giveTab')} style={{marginRight: 10}}/> {t('request.giveTab')}</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href={t('link.requests_leave')} className="d-flex align-items-center dropdown_list_item"><MdWorkOff size={24} title={t('request.leaveTab')} style={{marginRight: 10}}/> {t('request.leaveTab')}</NavDropdown.Item>
                <NavDropdown.Item href={t('link.leave_create')} className="d-flex align-items-center dropdown_list_item"><MdWorkOff size={24} title={t('request.createLeaveTab')} style={{marginRight: 10}}/> {t('request.createLeaveTab')}</NavDropdown.Item>
            </NavDropdown>
        } 

        {/* <Nav.Link onClick={() => handleNavigation(t('link.settings')} className="sidebar-icon"> */}
        <Nav.Link as={NavLink} to={t('link.settings')}
          onClick={(e) => {
            if (window.location.pathname === t('link.settings')) {
              e.preventDefault(); // prevent navigation
            }
          }}
          className={`sidebar-icon ${isActive(t('link.settings')) ? 'active sidebar-active-icon text-primary' : ''}`}>
          <FaGear size={24} title="Paramètres"/> 
          {/* <span className="sidebar-text">Paramètres</span> */}
        </Nav.Link>
        <Nav.Link onClick={logOut} className="sidebar-icon mt-auto">
          <IoMdLogOut size={24} title={t('navBar.signout')} /> 
          {/* <span className="sidebar-text">Déconnexion</span> */}
        </Nav.Link>
      </Nav>
    </div>
  );
};

export default Sidebar;
